import Scriba from 'react-scriba';

export class DataDocumentOperation {

    static _chargementDocumentDossierClientOperation() {
        let objet = {};

        var url = "api/Get/GetDocumentsDossierClientOperation";
        var paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _onEnregistrementDocumentDossierClientOperation(idOperation, listDocumentsAImporter) {
        let objet = {
            "idOperation": idOperation,
            "listDocuments": listDocumentsAImporter
        };

        let url = "api/MAJDonnees/EnregistrementDocumentDossierClientOperation";
        let paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _onEnregistrementRangDocumentDossierClientOperation(idOperation, listDocuments) {
        let objet = {
            "idOperation": idOperation,
            "listDocuments": listDocuments
        };

        let url = "api/MAJDonnees/EnregistrementRangDocumentDossierClientOperation";
        let paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _onSuppressionDocumentDossierClientOperation(idOperation, idTemplate, idInstance, rowGUID) {
        let objet = {
            "idOperation": idOperation,
            "idTemplate": idTemplate,
            "idInstance": idInstance,
            "rowGUID": rowGUID
        };

        let url = "api/MAJDonnees/SuppressionDocumentDossierClientOperation";
        let paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }
}